import { v4 as uuidv4 } from "uuid";
import { format } from "date-fns";
export class PAReviewItemModel {
    constructor() {
        this.reviewId = uuidv4();
        this.cycleId = uuidv4();
        this.cycleName = "";
        this.status = "";
        this.period = "";
        this.isClientInterfacer = false;
        this.needsAction = false;
        this.reviewees = [];
        this.paCycleStatusSummary = [];
        this.meetingStatus = "";
    }
    formattedDate() {
        if (!this.startDate && !this.endDate) {
            return "";
        }
        const startDateFormatted = format(new Date(this.startDate), "MMM d, yyyy");
        const endDateFormatted = format(new Date(this.endDate), "MMM d, yyyy");
        return `${startDateFormatted} - ${endDateFormatted}`;
    }
}
export default class PAReviewItem extends PAReviewItemModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
